var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-layout"},[_c('section',{staticClass:"page-layout-main"},[_vm._t("default")],2),_c('section',{staticClass:"page-layout-side"},[_vm._t("side")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }